import React from 'react';
import Link, { withPrefix } from 'gatsby-link';

import './_footer.scss';

class Footer extends React.Component {
  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  render() {
    return (
      <footer className="site-footer" data-aos="fade-up" data-aos-once>
        <div className="wrapper">
          <div className="inner-wrapper">
            <div className="row">
              <div className="col-md-3 col-section">
                <a className="navbar-brand">
                  <img alt="FirstStep logo" src={withPrefix('/images/logos/logo.png')} />
                  <p>FirstStep</p>
                </a>
                <div className="download-links">
                  <a href="https://itunes.apple.com/au/app/firststep/id1139641100" target="_blank" rel="noopener" className="btn-download appstore"><img src="/images/logos/app-stores/app-store-button.png" alt="App Store download icon" /></a>
                  <a href="https://play.google.com/store/apps/details?id=co.firststep.app" target="_blank" rel="noopener" className="btn-download playstore"><img src="/images/logos/app-stores/play-store-button.png" alt="Google Play download icon" /></a>
                </div>

                <div className="row justify-content-center align-items-center social-shares">
                  <div className="col col-md-6 col-lg-3 align-self-center">
                    <a href="https://www.facebook.com/getfirststep/" target="_blank" rel="noopener" aria-label="Facebook page">
                      <i aria-hidden className="fab fa-facebook-f" />
                    </a>
                  </div>
                  <div className="col col-md-6 col-lg-3 align-self-center">
                    <a href="https://twitter.com/getfirststep/" target="_blank" rel="noopener" aria-label="Twitter page">
                      <i aria-hidden className="fab fa-twitter" />
                    </a>
                  </div>
                  <div className="col col-md-6 col-lg-3 align-self-center">
                    <a href="https://www.linkedin.com/company/getfirststep/" target="_blank" rel="noopener" aria-label="LinkedIn page">
                      <i aria-hidden className="fab fa-linkedin-in" />
                    </a>
                  </div>
                  <div className="col col-md-6 col-lg-3 align-self-center">
                    <a href="https://medium.com/@GetFirstStep/" target="_blank" rel="noopener">
                      <img className="w-50" src={withPrefix('/images/icons/icon-m.svg')} alt="Medium Blog icon" />
                    </a>
                  </div>
                </div>

              </div>
              <div className="col-md-3 col-section footer-links">
                <h4>Legal</h4>
                <ul>
                  <li>
                    <Link to="/terms-and-conditions">Terms &amp; conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy policy</Link>
                  </li>
                  {/* <li>
                    <a target="_blank" rel="noopener" href="/documents/FirstStep-Fund-PDS.pdf">Product disclosure statement</a>
                  </li> */}
                  {/* <li>
                    <a target="_blank" rel="noopener" href="/documents/FirstStep-Fund-PDS-Investment-Options-Booklet.pdf">Investment option booklet</a>
                  </li> */}
                  {/* <li>
                    <a target="_blank" rel="noopener" href="/documents/FirstStep-Fund-PDS-Additional-Information-Booklet.pdf">Addtional information booklet</a>
                  </li> */}
                </ul>
              </div>
              <div className="col-md-3 col-section footer-links">
                <h4>Company</h4>
                <ul>
                  <li>
                    <Link to="/how-to-firststep">How to FirstStep</Link>
                  </li>
                  <li>
                    <Link to="/about">About us</Link>
                  </li>
                  <li>
                    <Link to="/pricing">Pricing</Link>
                  </li>
                  <li>
                    <Link to="/why-firststep">Why FirstStep</Link>
                  </li>
                  <li>
                    <Link to="/faq">FAQs</Link>
                  </li>
                  <li>
                    <Link to="/press">Press</Link>
                  </li>
                  <li><a href="https://medium.com/@GetFirstStep" target="_blank" rel="noopener">Blog</a></li>
                </ul>
              </div>
              <div className="col-md-3 col-section">
                <h4>Where to find us</h4>
                <p className="address">Level 1, 333 Exhibition St Melbourne VIC 3000 Australia</p>
                {/* <p className="contact">
                  Call us:
                  {' '}
                  <a href="tel:03-8566-7771">03 8566 7771</a>
                </p> */}
                <p className="contact">
                  Email at:
                  {' '}
                  <a href="mailto:hello@firststep.co">hello@firststep.co</a>
                </p>
              </div>
            </div>
            <div className="row text-center justify-content-center">
              <div className="col-12">
                <p className="copyright">FirstStep is licensed to operate in Australia and only Australian citizens and residents can purchase or sell securities through its application. FirstStep is owned and operated by FirstStep Investments Australia Pty Ltd (ACN 612 834 947) - Authorised Representative of Primestock Securities Ltd, AFSL 239180. Equity Trustees Limited (“Equity Trustees”) (ABN 46 004 031 298), AFSL 240975, is the Responsible Entity for the FirstStep Fund.  Equity Trustees is a subsidiary of EQT Holdings Limited (ABN 22 607 797 615), a publicly listed company on the Australian Securities Exchange (ASX: EQT).</p>
                <p className="mt-0 copyright">This website has been prepared by FirstStep Investments Australia Pty Ltd, to provide you with general information only. In preparing this website, we did not take into account the investment objectives, financial situation or particular needs of any particular person. It is not intended to take the place of professional advice and you should not take action on specific issues in reliance on this information. Neither FirstStep Investments Australia Pty Ltd, Equity Trustees nor any of its related parties, their employees or directors, provide and warranty of accuracy or reliability in relation to such information or accepts any liability to any person who relies on it. Past performance should not be taken as an indicator of future performance. You should obtain a copy of the Product Disclosure Statement before making a decision about whether to invest in this product.</p>
                <p className="reserved-date">
                  © FirstStep
                  {' '}
                  {new Date().getFullYear()}
                  . All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js